export default __webpack_public_path__ + "static/media/elephant_standup.61c55148.png";